import { createFileRoute } from "@tanstack/react-router";
import { canonicalMunicipalitySlug, permanentRedirect } from "@/lib/legacyRedirects";

/**
 * Gamla adresser av typen /dagens-spotpris/SE04-Helsingborg pekas om till
 * kommunens elprissida (eller elområdet om ingen kommun anges).
 */
export const Route = createFileRoute("/dagens-spotpris/$slug")({
  beforeLoad: ({ params }) => {
    const raw = params.slug ?? "";
    const match = /^se0?([1-4])(?:-(.*))?$/i.exec(raw);
    const rest = match ? (match[2] ?? "") : raw;
    if (!rest) {
      const area = match?.[1];
      permanentRedirect(area ? `/elpriser/elomrade-${area}` : "/elpriser/idag");
    }
    permanentRedirect(`/elpriser/${canonicalMunicipalitySlug(rest)}`);
  },
});
